<template>
  <button :class="classes" @click="onClick">
    <div class="trbo-a-question-next-button__wrapper">
      <icon :name="icon" class="trbo-a-question-next-button__icon" />
      <div class="trbo-a-question-next-button__title">
        {{ label }}
      </div>
    </div>
  </button>
</template>

<script>
// @flow

import { mapGetters, mapState } from 'vuex'

import Icon from '../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  computed: {
    ...mapState(['isLoadingProducts']),
    ...mapGetters(['moreProductsButtonTitle']),
    classes () {
      return {
        'trbo-a-question-next-button': true,
        'trbo-a-question-next-button--is-current-products-page': true,
        'trbo-a-question-next-button--is-loading-products': this.isLoadingProducts,
        'trbo-a-question-next-button--is-disabled': this.isLoadingProducts
      }
    },
    icon () {
      if (this.isLoadingProducts) return 'typing'
      return 'reload'
    },
    label () {
      if (this.moreProductsButtonTitle) return this.moreProductsButtonTitle

      return this.$t('product.loadMore')
    }
  },
  methods: {
    onClick () {
      this.$emit('click', 'load-more-products')
    }
  }
}
</script>

<style scoped src="../NextButton/next-button.scss" />
